__webpack_require__.S = {};
const initPromises = {};
const initTokens = {};
__webpack_require__.I = (name, initScope) => {
	if(!initScope) initScope = [];
	// handling circular init calls
	let initToken = initTokens[name];
	if(!initToken) initToken = initTokens[name] = {};
	if(initScope.indexOf(initToken) >= 0) return;
	initScope.push(initToken);
	// only runs once
	if(initPromises[name]) return initPromises[name];
	// creates a new share scope if needed
	if(!__webpack_require__.o(__webpack_require__.S, name)) __webpack_require__.S[name] = {};
	// runs all init snippets from all modules reachable
	const scope = __webpack_require__.S[name];
	const warn = (msg) => {
		if (typeof console !== "undefined" && console.warn) console.warn(msg);
	};
	const uniqueName = "@frontend/shell";
	const register = (name, version, factory, eager) => {
		const versions = scope[name] = scope[name] || {};
		const activeVersion = versions[version];
		if(!activeVersion || (!activeVersion.loaded && (!eager != !activeVersion.eager ? eager : uniqueName > activeVersion.from))) versions[version] = { get: factory, from: uniqueName, eager: !!eager };
	};
	const initExternal = (id) => {
		const handleError = (err) => (warn("Initialization of sharing external failed: " + err));
		try {
			const module = __webpack_require__(id);
			if(!module) return;
			const initFn = (module) => (module && module.init && module.init(__webpack_require__.S[name], initScope))
			if(module.then) return promises.push(module.then(initFn, handleError));
			const initResult = initFn(module);
			if(initResult?.then) return promises.push(initResult['catch'](handleError));
		} catch(err) { handleError(err); }
	}
	const promises = [];
	switch(name) {
		case "default": {
			register("@aws-amplify/ui-react", "6.15.4", () => (Promise.all([__webpack_require__.e(9703), __webpack_require__.e(8110), __webpack_require__.e(5765), __webpack_require__.e(5641), __webpack_require__.e(9163), __webpack_require__.e(6110)]).then(() => (() => (__webpack_require__(5765))))));
			register("@coworker/shared-library", "0.0.1", () => (Promise.all([__webpack_require__.e(5641), __webpack_require__.e(7505), __webpack_require__.e(9755)]).then(() => (() => (__webpack_require__(2136))))));
			register("aws-amplify", "6.18.0", () => (Promise.all([__webpack_require__.e(9703), __webpack_require__.e(7541)]).then(() => (() => (__webpack_require__(7541))))));
			register("axios", "1.18.1", () => (__webpack_require__.e(9543).then(() => (() => (__webpack_require__(9543))))));
			register("react-dom", "18.3.1", () => (Promise.all([__webpack_require__.e(3144), __webpack_require__.e(5641)]).then(() => (() => (__webpack_require__(763))))));
			register("react-router-dom", "6.30.4", () => (Promise.all([__webpack_require__.e(8955), __webpack_require__.e(5641), __webpack_require__.e(9163)]).then(() => (() => (__webpack_require__(8955))))));
			register("react", "18.3.1", () => (__webpack_require__.e(4041).then(() => (() => (__webpack_require__(4041))))));
			register("socket.io-client", "^4.7.2", () => (() => (__webpack_require__(5476))), 1);
			register("styled-components", "6.4.3", () => (Promise.all([__webpack_require__.e(3360), __webpack_require__.e(5641)]).then(() => (() => (__webpack_require__(3360))))));
			register("uniqid", "5.4.0", () => (__webpack_require__.e(2390).then(() => (() => (__webpack_require__(2390))))));
			initExternal(7013);
			initExternal(5861);
			initExternal(3537);
			initExternal(161);
			initExternal(1217);
			initExternal(1199);
			initExternal(7843);
			initExternal(4977);
			initExternal(2647);
		}
		break;
	}
	if(!promises.length) return initPromises[name] = 1;
	return initPromises[name] = Promise.all(promises).then(() => (initPromises[name] = 1));
};